import { useRef } from "react";
import { Tooltip } from '@chakra-ui/react';

export interface TooltipProps {
    children: React.ReactNode;
    label: String;
}

const ChakraTooltip = (props: TooltipProps) => {
    const ref = useRef(null);

    return (
        <Tooltip hasArrow label={props.label} bg={'gray.600'} portalProps={{ containerRef: ref }}>
            <div ref={ref}>
                {props.children}
            </div>
        </Tooltip>
    );
}

export default ChakraTooltip;